/**
 * CourseSessionTypeService
 * Service for CourseSessionType entity operations
 * Route: api/course-session-types
 */
import { BaseService } from '../base/BaseService';
/**
 * CourseSessionTypeService
 * Handles course session type CRUD operations
 */
export class CourseSessionTypeService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseSessionTypeService.DEFAULT_SERVICE_PATH,
            basePath: CourseSessionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all course session types
     * @returns Promise resolving to array of course session types
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all course session types (raw response)
     * @returns Promise resolving to ResponseData with course session types
     */
    getAllRaw() {
        const url = this.buildUrl('');
        return this.http.get(url);
    }
    /**
     * Get course session type by ID
     * @param id - Type ID
     * @returns Promise resolving to course session type or null
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    /**
     * Get course session type by ID (raw response)
     * @param id - Type ID
     * @returns Promise resolving to ResponseData with course session type
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('getById', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Create a new course session type
     * @param type - Type data
     * @returns Promise resolving to created course session type
     */
    async create(type) {
        const response = await this.createRaw(type);
        return response.data ?? null;
    }
    /**
     * Create a new course session type (raw response)
     * @param type - Type data
     * @returns Promise resolving to ResponseData with created course session type
     */
    createRaw(type) {
        const url = this.buildUrl('');
        return this.http.post(url, type);
    }
    /**
     * Update an existing course session type
     * @param id - Type ID
     * @param type - Updated type data
     * @returns Promise resolving to updated course session type
     */
    async update(id, type) {
        const response = await this.updateRaw(id, type);
        return response.data ?? null;
    }
    /**
     * Update an existing course session type (raw response)
     * @param id - Type ID
     * @param type - Updated type data
     * @returns Promise resolving to ResponseData with updated course session type
     */
    updateRaw(id, type) {
        const endpoint = this.getEndpoint('update', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, type);
    }
    /**
     * Delete a course session type
     * @param id - Type ID
     * @returns Promise resolving to true if successful
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete a course session type (raw response)
     * @param id - Type ID
     * @returns Promise resolving to ResponseData
     */
    deleteRaw(id) {
        const endpoint = this.getEndpoint('delete', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
CourseSessionTypeService.DEFAULT_SERVICE_PATH = 'resources';
CourseSessionTypeService.BASE_PATH = 'api/course-session-types';
//# sourceMappingURL=CourseSessionTypeService.js.map